import { topicGroups } from "@/mocks/guaData";

export default function Topics() {
  return (
    <section id="topics" className="px-4 md:px-8 py-12 md:py-16 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-1.5 text-accent-600 font-medium text-sm">
            <i className="ri-megaphone-fill"></i> 专题节目 · 热点事件深度解读
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-2">
            吃瓜也要吃得明白，专题盘点更深度
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-3 leading-relaxed">
            每个专题都是一次有头有尾的热点复盘，把散落的信息串成完整故事线，让你不只看到瓜，更看懂瓜。
          </p>
        </div>

        <div className="mt-8 md:mt-12 grid md:grid-cols-2 gap-5 md:gap-6">
          {topicGroups.map((topic, i) => (
            <article
              key={topic.id}
              className="group relative rounded-2xl overflow-hidden min-h-[300px] md:min-h-[340px] flex items-end bg-foreground-900"
            >
              <img
                src={topic.cover}
                alt={`${topic.title}专题配图`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent"></div>
              <div className="relative z-10 p-6 md:p-8 w-full">
                <div className="flex items-center gap-2 flex-wrap">
                  <span
                    className={`px-2.5 py-1 rounded text-xs font-semibold text-background-50 ${
                      i % 2 === 0 ? "bg-primary-500" : "bg-accent-500"
                    }`}
                  >
                    {topic.kicker}
                  </span>
                  <span className="px-2.5 py-1 rounded text-xs text-background-50/90 bg-background-50/20 backdrop-blur">
                    {topic.participate}
                  </span>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-white mt-3 leading-snug">
                  {topic.title}
                </h3>
                <p className="text-white/85 text-sm md:text-[15px] mt-2 leading-relaxed line-clamp-2">
                  {topic.summary}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-accent-300 text-sm font-medium hover:text-accent-200">
                  查看专题全部内容 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}